var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.vHtml)?_c(_vm.linkType,_vm._b({tag:"component",domProps:{"innerHTML":_vm._s(_vm.vHtml)}},'component',_vm.linkProps,false)):_c(_vm.linkType,_vm._b({tag:"component"},'component',_vm.linkProps,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }